import { Checkbox, FormControlLabel, FormGroup, Tooltip } from "@mui/material";
import "./ReceivingNlaModal.scss";
import { useEffect, useRef, useState } from "react";
import Input from "../../../../../../components/Inputs/Input";
import MultioptionButton from "../../../../../../components/Buttons/MultioptionButton";
import { ReceivingETExpandable } from "../ReceivingETExpandable/ReceivingETExpandable";
import { useDispatch, useSelector } from "react-redux";
import {
  getActualsSvc,
  getNLAHierarchySvc,
  getReceivingET,
  saveInitialPartActualsSvc,
} from "../../../../Services/receivingManagementService";
import { HTTP_RESPONSE_CODES } from "../../../../../../globals/globals";
import {
  clearParts,
  clearSelectedNLA,
  setParts,
} from "../../../../../../redux/features/StoresModule/nlaReceivingSlice";
import { SortingProvider } from "../../../../../../contexts/SortingContext";
import { SortingHeader } from "../../../../../../components/Sorting/SortingHeader";
import { NLAContainer } from "../NLAContainer/NLAContainer";
import { ResultsNotFound } from "../../../../../../components/ResultsNotFound/ResultsNotFound";
// Ejemplo de mockData que simula lo que devolvería el backend

export const ReceivingNlaModal = ({
  onClose,
  part_id,
  pn,
  serialNum,
  description,
  isPurchaseOrder = false,
}) => {
  const [quickSN, setQuickSN] = useState(false);
  const [editActuals, setEditActuals] = useState(false);
  const [sorting, setSorting] = useState(null);
  const [selectedNLAActuals, setSelectedNlaActuals] = useState(null);
  const [selectedNLAEts, setSelectedNlaEt] = useState([]);
  const [actualsForm, setActualsForm] = useState({
    totalHours: null,
    totalCycles: null,
    totalDays: null,
    version: 0,
  });
  const partNLAs = useSelector((state) => state.receivingNla.parts ?? []);
  const selectedNLA = useSelector(
    (state) => state.receivingNla.selectedNla ?? null
  );

  const dispatch = useDispatch();
  const [openedNodeId, setOpenedNodeId] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [hasScroll, setHasScroll] = useState(false);
  const parytListRef = useRef(null);

  // functions
  const getReceivingNLA = async (id) => {
    let request = await getNLAHierarchySvc(id);
    if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
      dispatch(setParts([...request.data.load]));
    }
  };
  const getPartActuals = async (partId) => {
    let request = await getActualsSvc(partId);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setSelectedNlaActuals(request.data.load);
    }
  };

  const getPartEt = async (id) => {
    let request = await getReceivingET(id);
    if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
      setSelectedNlaEt(request.data.load);
    }
  };

  const savePartActuals = async (typeFinish) => {
    let body = {
      serializedPartId: selectedNLA.serializedPartId,
      actualFlight: {
        totalFlightHours: actualsForm.totalHours,
        totalFlightMinutes: 0,
        totalFlightCycles: actualsForm.totalCycles,
      },
    };
    let request = await saveInitialPartActualsSvc(body);

    if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
      console.log(request.data.load);
    }
  };

  const openNodeDetail = (node, shouldEdit = false) => {
    setOpenedNodeId(node.nodeId);
    setEditMode(shouldEdit);

    if (node.parentIds && node.parentIds.length > 0) {
    }
  };
  const handleAssignSN = () => {
    if (selectedNLA) {
      openNodeDetail(selectedNLA, true);
    }
  };

  // effects

  useEffect(() => {
    if (selectedNLA && selectedNLA.serializedPartId) {
      getPartActuals(selectedNLA.serializedPartId);
    }
    if (selectedNLA) {
      getPartEt(selectedNLA?.partId);
    }
  }, [selectedNLA]);

  useEffect(() => {
    getReceivingNLA(part_id);
  }, [part_id]);

  useEffect(() => {
    return () => {
      dispatch(clearSelectedNLA());
      dispatch(clearParts());
    };
  }, []);
  useEffect(() => {
    const checkScroll = () => {
      if (parytListRef.current) {
        const el = parytListRef.current;
        setHasScroll(el.scrollHeight > el.clientHeight);
      }
    };

    checkScroll();
    const t = setTimeout(checkScroll, 10);
    return () => clearTimeout(t);
  }, [partNLAs]);

  const multiOptionsBtn = [
    { label: "Save", icon: "icon-save", id: "save" },
    { label: "Save And Continue", icon: "icon-save", id: "save-and-continue" },
    { label: "Cancel", icon: "icon-cross", id: "cancel", type: "danger" },
  ];

  const buttonsCallback = {
    save: () => {
      savePartActuals("finish");
    },
    "save-continue": () => {
      savePartActuals("continue");
    },
    cancel: () => {
      setEditActuals(false);
    },
  };

  return (
    <SortingProvider
      properties={{
        partNumber: "PN",
        serialNumber: "SN",
        positions: "Position",
        nlaQty: "NLA QTY",
        etQty: "ET QTY",
      }}
      onOrderChange={(e) => {
        setSorting(e);
      }}
    >
      <div className="receiving-nla-modal">
        <div className="receiving-nla-modal-header">
          <h3>NLA PN SN</h3>
          <p>
            PN <span>{pn || "--"}</span>
          </p>
          <p>
            SN <span>{serialNum || "--"}</span>
          </p>
          <p>
            Description <span>{description || "--"}</span>
          </p>
          <button className="outlined icon small-size" onClick={onClose}>
            <i className="icon-cross"></i>
          </button>
        </div>
        <div className="receiving-nla-modal-content">
          <div className="receiving-nla-modal-content-left">
            <div>
              {/* <h3>NLA Available</h3> */}
              <div
                className={`${quickSN ? "container-check-checked" : ""}`}
                style={{
                  background: !quickSN ? "var(--white)" : "",
                  paddingLeft: "var(--padding)",
                  height: "2rem",
                  width: "7rem",
                  display: "inline-block",
                  alignItems: "center",
                  minWidth: "7rem",
                  borderRadius: "var(--radius)",
                  // justifyContent : "center"
                }}
              >
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={(e) => {
                          setQuickSN(e.target.checked);
                        }}
                      />
                    }
                    label={
                      <p
                        style={{
                          color: "var(--black-mid)",
                          fontSize: "calc(var(--p-size) + .1rem)",
                        }}
                      >
                        Quick SN
                      </p>
                    }
                  />
                </FormGroup>
              </div>
              <div>
                {/* <p>Vendor Lot </p>
              <Input
                disabled={true}
                value={vendorLot}
                style={{
                  width: "7.5rem",
                }}
              ></Input> */}
              </div>
            </div>
            <div className="receiving-nla-modal-content-left-columns">
              {/* <p>PN</p>
              <p>SN</p>
              <p>Position</p>
              <p>NLA QTY</p>
              <p>ET QTY</p> */}
              <SortingHeader></SortingHeader>
            </div>
            <section
              ref={parytListRef}
              className="receiving-nla-modal-content-left-NLS-cont"
              style={{
                width: "100%",
                // height: "calc(80% - var(--padding))",
                flexGrow: "1",
                display: "flex",
                flexDirection: "column",
                gap: "calc(var(--gap) - .3rem)",
                overflow: "hidden auto",
                paddingRight: hasScroll ? "var(--padding)" : "",
              }}
            >
              <NLAContainer
                partNLAs={partNLAs}
                quickSN={quickSN}
                sortCriteria={sorting}
                isPo={isPurchaseOrder}
                openedNodeId={openedNodeId}
                editMode={editMode}
                onCloseDetail={() => {
                  setOpenedNodeId(null);
                  setEditMode(false);
                }}
                reloadNLAList={() => {
                  getReceivingNLA(part_id);
                }}
              />
            </section>
          </div>
          <div className="receiving-nla-modal-content-right">
            {selectedNLA ? (
              selectedNLA.serializedPartId ? (
                <>
                  <div className="receiving-nla-modal-content-right-pn-header">
                    <p>
                      PN <span>{selectedNLA?.partNumber || "--"}</span>
                    </p>
                    <p>
                      SN <span>{selectedNLA?.serialNumber || "--"}</span>
                    </p>
                    <p>
                      Position <span>{selectedNLA?.positions || "--"}</span>
                    </p>
                    <p>
                      NLA QTY{" "}
                      <span
                        style={{
                          // height: "1.2rem",
                          // width: "1.2rem",
                          padding: "var(--padding)",
                          color: "var(--white)",
                          background: "var(--black-mid)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "var(--radius)",
                          minHeight: "1.3rem",
                          maxHeight: "1.3rem",
                          minWidth: "1.3rem",
                          maxWidth: "2.5rem",
                        }}
                      >
                        {selectedNLA?.nlaQty || "0"}
                      </span>
                    </p>
                    <p>
                      ET QTY{" "}
                      <span
                        style={{
                          // height: "1.2rem",
                          // width: "1.2rem",
                          padding: "var(--padding)",
                          color: "var(--white)",
                          background: "var(--black-mid)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "var(--radius)",
                          minHeight: "1.3rem",
                          maxHeight: "1.3rem",
                          minWidth: "1.3rem",
                          maxWidth: "2.5rem",
                        }}
                      >
                        {0}
                      </span>
                    </p>
                  </div>
                  <section className="receiving-nla-modal-actuals-cont">
                    {" "}
                    <div>
                      <h3>Actuals</h3>
                      <p>Total Hours</p>
                      <Input
                        disabled={!editActuals}
                        style={{
                          width: "4rem",
                          // flexGrow : "1"
                        }}
                        // label={"Total Hours"}
                        isNumeric={true}
                        value={actualsForm.totalHours}
                        onChange={(e) => {
                          setActualsForm((prev) => {
                            return { ...prev, totalHours: e.target.value };
                          });
                        }}
                      ></Input>
                      <p>Total Cycles</p>

                      <Input
                        disabled={!editActuals}
                        style={{
                          width: "4rem",
                          // flexGrow : "1"
                        }}
                        // label={"Total Cycles"}
                        isNumeric={true}
                        value={actualsForm.totalCycles}
                        onChange={(e) => {
                          setActualsForm((prev) => {
                            return { ...prev, totalCycles: e.target.value };
                          });
                        }}
                      ></Input>
                      <p>Total Days</p>

                      <Input
                        disabled={!editActuals}
                        style={{
                          width: "4rem",
                          // flexGrow : "1"
                        }}
                        // label={"Total Days"}
                        isNumeric={true}
                        onChange={(e) => {
                          setActualsForm((prev) => {
                            return { ...prev, totalDays: e.target.value };
                          });
                        }}
                        value={actualsForm.totalDays}
                      ></Input>
                    </div>
                    <section
                      style={{
                        // flexGrow: "1",
                        width: "20%",
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      {editActuals ? (
                        <MultioptionButton
                          buttons={multiOptionsBtn}
                          buttonCallbacks={buttonsCallback}
                        ></MultioptionButton>
                      ) : (
                        // <Tooltip
                        //   title={
                        //     selectedNLA?.serializedPartId === null
                        //       ? "ETs cannot be edited if the part does not have a Serial Number (SN). Please assign an SN to the selected NLA part."
                        //       : ""
                        //   }
                        //   arrow
                        // >
                        <button
                          // disabled={selectedNLA?.serializedPartId === null}
                          onClick={() => setEditActuals(!editActuals)}
                          className="btn-receiving-edit-actuals"
                        >
                          {" "}
                          <i className="icon-edit"></i> Edit
                        </button>
                        // </Tooltip>
                      )}
                    </section>
                  </section>
                  <section className="receiving-nla-modal-et-cont">
                    <div>
                      <p>ET</p>
                      <p>Description</p>
                      <p>Use Flight Days</p>
                      <p>Repeat Number</p>
                      <p>Completed Number</p>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        // height: "calc(80% - var(--padding))",
                        flexGrow: "1",
                        display: "flex",
                        flexDirection: "column",
                        gap: "calc(var(--gap) - .3rem)",
                        overflow: "hidden auto",
                        paddingRight: "var(--padding)",
                      }}
                    >
                      {selectedNLAEts.length > 0 ? (
                        selectedNLAEts.map((e) => {
                          return (
                            <ReceivingETExpandable
                              key={e.id}
                              data={e}
                              hasSN={
                                selectedNLA.serializedPartId === null
                                  ? false
                                  : true
                              }
                            />
                          );
                        })
                      ) : (
                        <ResultsNotFound></ResultsNotFound>
                      )}
                    </div>
                  </section>{" "}
                </>
              ) : (
                <div className="receiving-nla-modal-part-without-sn">
                  <p
                    style={{
                      textAlign: "center",
                      color: "var(--black-mmid)",
                      fontWeight: "500",
                    }}
                  >
                    The selected Part Number does not have a Serial Number
                    assigned. <br /> Consequently, Engineering Tasks and Actuals
                    are not available for viewing. <br /> To proceed, please
                    assign a Serial Number to this Part Number in order to
                    access its related data.
                  </p>
                  <button onClick={handleAssignSN}>Assign Serial Number</button>
                </div>
              )
            ) : (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "var(--gap)",
                }}
              >
                <i className="icon-info"></i>
                <p
                  style={{
                    textAlign: "center",
                    color: "var(--black-mmid)",
                    fontWeight: "500",
                  }}
                >
                  No data available to display, Please select a part first in
                  the NLA section.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </SortingProvider>
  );
};
